import { cn } from '@/lib/utils';
import type { MonthFilter } from '@/contabilidad/hooks/useDateRangeFilter';

const MONTHS = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'] as const;

interface DateRangeFilterProps {
  activeMonth: MonthFilter;
  onSelectMonth: (month: MonthFilter) => void;
  className?: string;
}

export function DateRangeFilter({ activeMonth, onSelectMonth, className }: DateRangeFilterProps) {
  return (
    <div className={cn('flex items-center gap-2 flex-wrap', className)}>
      <div className="flex flex-wrap items-center gap-1 bg-gray-100 rounded-2xl px-2 py-1 border border-gray-200 max-w-full">
        <button
          onClick={() => onSelectMonth('todos')}
          className={cn(
            'px-3 py-1 rounded-full text-xs font-semibold transition-colors whitespace-nowrap',
            activeMonth === 'todos'
              ? 'bg-white text-primary shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          )}
        >
          Todos
        </button>
        {MONTHS.map((m, i) => (
          <button
            key={m}
            onClick={() => onSelectMonth(i)}
            className={cn(
              'px-2.5 py-1 rounded-full text-xs font-medium transition-colors whitespace-nowrap',
              activeMonth === i
                ? 'bg-white text-primary shadow-sm font-semibold'
                : 'text-muted-foreground hover:text-foreground'
            )}
          >
            {m}
          </button>
        ))}
      </div>
    </div>
  );
}
